import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdSave } from 'react-icons/md';
import axios from 'axios';
import { CREATE_VENDOR_API } from '../config/API';
import Swal from 'sweetalert2';
import Loader from '../components/common/Loader';
import { showErrorToast } from '../utils/toastUtils';

const AddVendor = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        companyName: '',
        name: '',
        whatsappNumber: '',
        address: '',
        category: '',
        contactPerson: '',
        gst: '',
        pan: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.companyName) {
            showErrorToast('Company name is required');
            return;
        }

        const result = await Swal.fire({
            title: 'Save Vendor?',
            text: 'Do you want to save this vendor?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#4f46e5',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn',
            },
        });

        if (result.isConfirmed) {
            try {
                setLoading(true);
                const token = localStorage.getItem('accessToken');
                const response = await axios.post(CREATE_VENDOR_API, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (response.data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Saved!',
                        text: 'Vendor saved successfully',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    navigate('/vendors');
                } else {
                    showErrorToast(response.data.error || response.data.message || 'Failed to save vendor');
                }
            } catch (error) {
                console.error('Error saving vendor:', error);
                const errorData = error.response?.data?.errors || error.response?.data?.message || 'An error occurred';
                showErrorToast(errorData);
            } finally {
                setLoading(false);
            }
        }
    };

    if (loading) {
        return <Loader fullPage text="Saving vendor..." />;
    }

    return (
        <div className="add-vendor-page">
            <div className="page-header">
                <button onClick={() => navigate('/vendors')} className="back-btn">
                    <MdArrowBack />
                </button>
                <h2>Add New Vendor</h2>
            </div>

            <form onSubmit={handleSubmit} className="vendor-form">
                <div className="form-section">
                    <h3>Vendor Details</h3>
                    <div className="form-grid">
                        <div className="form-group full-width">
                            <label>Company Name<span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="companyName"
                                value={formData.companyName}
                                onChange={handleChange}
                                placeholder="Enter company name"
                            />
                        </div>
                        <div className="form-group full-width">
                            <label>Vendor Name <span className="required-star">*</span></label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter vendor name"
                            />
                        </div>
                        <div className="form-group">
                            <label>Contact Person</label>
                            <input
                                type="text"
                                name="contactPerson"
                                value={formData.contactPerson}
                                onChange={handleChange}
                                placeholder="Enter contact person name"
                            />
                        </div>
                        <div className="form-group">
                            <label>WhatsApp Number <span className="required-star">*</span></label>
                            <input
                                type="tel"
                                name="whatsappNumber"
                                value={formData.whatsappNumber}
                                onChange={handleChange}
                                placeholder="Enter WhatsApp number"
                            />
                        </div>
                        <div className="form-group full-width">
                            <label>Address</label>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                placeholder="Enter full address"
                            />
                        </div>
                        <div className="form-group">
                            <label>Category</label>
                            <input
                                type="text"
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                                placeholder="e.g. Electronics, Stationery"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-section">
                    <h3>Tax Information</h3>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>GST Number</label>
                            <input
                                type="text"
                                name="gst"
                                value={formData.gst}
                                onChange={handleChange}
                                placeholder="Enter GST number"
                            />
                        </div>
                        <div className="form-group">
                            <label>PAN Number</label>
                            <input
                                type="text"
                                name="pan"
                                value={formData.pan}
                                onChange={handleChange}
                                placeholder="Enter PAN number"
                            />
                        </div>
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" onClick={() => navigate('/vendors')} className="cancel-btn">
                        Cancel
                    </button>
                    <button type="submit" className="save-btn">
                        <MdSave /> Save Vendor
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddVendor;
